import React, { useState } from "react";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import UserMenuItem from "./UserMenuItem";
import { userMenuItems } from "./UserMenuContent";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { logout } from "store/features/authSlice";

import { routes } from "routes/routes";

import { ReactComponent as LogoutIcon } from "assets/images/sideMenu/logout-icon.svg";
import { ReactComponent as UserIcon } from "assets/images/sideMenu/user-menu-icon.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { Menu } from "./styles";

interface UserMenuProps {
  isCollapsed?: boolean;
}

const UserMenu: React.FC<UserMenuProps> = ({ isCollapsed = false }) => {
  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const loading = useAppSelector((state) => state.loading.isLoading);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = async () => {
    analytics().sendEvent(AnalyticsEvents.logout);
    await dispatch(logout()).unwrap();
  };

  return (
    <>
      <Box sx={{ ml: isCollapsed ? 0 : "auto" }}>
        <IconButton
          onClick={handleClick}
          size="small"
          aria-label="account-menu"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          sx={{
            width: 32,
            height: 32,
            p: 0,
          }}
        >
          <UserIcon />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {userMenuItems.map((item) => (
          <UserMenuItem key={item.route} item={item} />
        ))}
        <UserMenuItem
          item={{
            route: routes.auth,
            icon: LogoutIcon,
            name: "Вийти",
            loading,
            onClick: onLogout,
          }}
        />
      </Menu>
    </>
  );
};

export default UserMenu;
